import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';

const autocompleteService = { current: null };
const width100 = { width: '100%' }

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 9
    },
    "& .MuiInputLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600, // or black
    },
    "& .MuiInput-input": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "1rem",
    },
    "& .MuiFormLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600,
      fontSize: "0.8rem",
    },
    "& .MuiInputLabel-shrink": {
      transform: "scale(1.05)",
      transformOrigin: "top left",
    },
  }
}));

export default function AutoCompleteField(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(getDefaultValue());
  const [inputValue, setInputValue] = React.useState(props.label);
  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);
  const inputRef = React.useRef(null);

  let active = true;

  if (typeof window !== 'undefined' && !loaded.current) {

    loaded.current = true;
  }

  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        request.componentRestrictions = { country: ["us", "ca", "pt", "nl"] };
        request.types = ['address'];
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 2000),
    [],
  );

  React.useEffect(() => {
    // var options = {
    //   types: ['(cities)'],
    //   componentRestrictions: { country: ["us", "ca"] }
    // };

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
      // autocompleteService.current.setFields(["address_component"]);
      // autocompleteService.current.setComponentRestrictions({
      //   country: ["us", "ca",]
      // });
    }

    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, onRequestCallBack);

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch, props.defaultValue]);

  return (
    <Autocomplete
      id="google-map-demo"
      style={props.width}
      getOptionLabel={getOptionLabel}
      filterOptions={filterOptions}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      renderInput={renderInput}
      renderOption={renderOption}
    />
  );

  function onRequestCallBack(results) {
    if (active) {
      let newOptions = [];

      if (value) {
        props.onEditCallBack(value);
        newOptions = [value];
      }

      if (results) {
        newOptions = [...newOptions, ...results];
      }

      setOptions(newOptions);
    }
  }

  function getDefaultValue() {
    return props.defaultValue !== '' ? props.defaultValue : null;
  }

  function filterOptions(x) {
    return x
  }

  function getOptionLabel(option) {
    return (typeof option === 'string' ? option : option.description)
  }

  function onInputChange(event, newInputValue) {
    setInputValue(newInputValue);
  }

  function onChange(event, newValue) {
    setOptions(newValue ? [newValue, ...options] : options);
    setValue(newValue);
  }

  function renderOption(option) {
    if (option.structured_formatting) {
      const matches = option.structured_formatting.main_text_matched_substrings;
      const parts = parse(
        option.structured_formatting.main_text,
        matches.map((match) => [match.offset, match.offset + match.length]),
      );

      return (
        <Grid container alignItems="center">
          {/* <Grid item>
          <LocationOnIcon className={classes.icon} />
        </Grid> */}
          <Grid item xs>
            {parts.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}

            <Typography variant="body2" color="textSecondary">
              {option.structured_formatting.secondary_text}
            </Typography>
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  }

  function renderInput(params) {
    return (
      <TextField {...params} error={value === '' || value === null && props.navAttempts > 0} helperText={props.helperText} className={classes.root} label={props.label} variant="standard" style={width100} />
    )
  }
}
